export default __webpack_public_path__ + "static/media/640_store04-jp-mobile.810f675d.png";